import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createLabTest, deleteLabTestAsync, fetchLabTestTypes, updateLabTestAsync, labTestLoading} from "../../../ReduxSlices/Admin/labTestServiceSlice";
import LoadingDots from "../../shared/LoadingDots";


const LabServices = () => {
  const dispatch = useDispatch();
  const { labTests, submitting, error } = useSelector((state) => state.labServices)
   const [formData, setFormData] = useState({ name: "", unit_price: "" });
  const [editingTest, setEditingTest] = useState(null);
  const [activeTab, setActiveTab] = useState("list");
  const loading = useSelector(labTestLoading);

  useEffect(() => {
   if(labTests.length === 0) {
    dispatch(fetchLabTestTypes());
   }
  }, [dispatch, labTests.length]);

const handleChange = (e) => {
  const value = e.target.name === "unit_price" ? Number(e.target.value) : e.target.value;
  setFormData({ ...formData, [e.target.name]: value });
};


  const handleSubmit = async (e) => {
    e.preventDefault();

      if (editingTest) {
      await dispatch(updateLabTestAsync({ id: editingTest.id, data: formData }));
    } else {
      await dispatch(createLabTest(formData));
    }

      if (!error) {
      setFormData({ name: "", unit_price: "" });
      setEditingTest(null);
      setActiveTab("list");
    } else {
      alert(error);
    }
  };
   
  const handleEdit = (test) => {
    setEditingTest(test);
    setFormData(test);
    setActiveTab("form"); 
  };

    const handleDelete = (id) => {
    if (window.confirm("Delete this test type?")) {
      dispatch(deleteLabTestAsync(id));
    }
  };


  return (
    <div className="space-y-6">
      <h2 className="text-xl font-bold">Lab Test Services</h2>
     

      {/* Tabs */}
      <div className="flex gap-[10px] mb-4">
      
        <button
          className={`px-4 py-2 rounded ${activeTab === "list" ? "primary" : "secondary"}`}
          onClick={() => setActiveTab("list")}
        >
          Lab Services
        </button>

          <button
          className={`px-4 py-2 rounded ${activeTab === "form" ? "primary" : "secondary"}`}
          onClick={() => setActiveTab("form")}
        >

         {editingTest ? "Update service" : "Add a lab service" }

        </button>
      </div>

      {/* Tab content */}
      {activeTab === "form" && (
        <form onSubmit={handleSubmit} className="user-form space-y-4 p-[20px]">
          <input
            type="text"
            name="name"
            placeholder="Test Name"
            value={formData.name}
            onChange={handleChange}
            className="border p-2 w-full rounded"
            required
          />
          <input
            type="number"
            name="unit_price"
            placeholder="Unit Price"
            value={formData.unit_price}
            onChange={handleChange}
            className="border p-2 w-full rounded"
            required
          />
          <div className="flex justify-between w-[45%]">
            <button className="primary wide" disabled={submitting}>
                {submitting
                ? (editingTest ? "Updating..." : "Adding...")
                : (editingTest ? "Update Test" : "Add Test")}
            </button>

             {editingTest && (
                <button
                  type="button"
                  className="secondary"
                  onClick={() => {
                    setEditingTest(null);
                    setFormData({ name: "", unit_price: "" });
                    setActiveTab("list");
                  }}
                >
                  Cancel
                </button>
              )}
          </div>
        </form>
      )}

      {activeTab === "list" && (
        loading ? (
        <LoadingDots />
      )
      : labTests.length === 0 ? (
     <div className="mt-[2rem]">
      <table className="w-full border-collapse">
        <thead>
          <tr className="bg-gray-100">
            <th className="border p-2 text-left">Name</th>
            <th className="border p-2 text-right">Price</th>
            <th className="border p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan="3" className="text-center p-4">
              No Lab data available.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  ) :(
        <div className="mt-[2rem]">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-100 ">
                <th className="border p-2 text-left">Name</th>
                <th className="border p-2 text-right">Price</th>
                <th className="border p-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {labTests.map((test) => (
                <tr key={test.id} className="lighten">
                  <td className="border p-2 text-left">{test.name}</td>
                  <td className="border p-2 text-right">
                      {new Intl.NumberFormat("en-KE", {
                        style: "currency",
                        currency: "KES",
                        minimumFractionDigits: 2,
                      }).format(test.unit_price)}
                    </td>
                  <td className="border p-2 text-center ">
                    <div className="action-btns">

                      <button
                        onClick={() => handleEdit(test)}
                        className="primary"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(test.id)}
                        className="secondary error-msg"
                      >
                        Delete
                      </button>

                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        )
      )}
    </div>
  );
};

export default LabServices;
